export default __webpack_public_path__ + "static/water-a406013c1e90b932fe5ae54e76f297ac.png";